// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimeTableItem_wrapper__tLBlL","container":"TimeTableItem_container__3Mg5k","actions":"TimeTableItem_actions__2dUj3"};